/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { ContainerBatch } from "../../../types/mediaBatchDispense.types";

interface Props {
	selectedContainerBatch: ContainerBatch | null;
}

const formatDate = (dateTimeString: string): string => {
  return dateTimeString.split(" ")[0];
};
const BatchLotInfoCards = ({ selectedContainerBatch }: Props) => {
	const { t } = useTranslation();

	const BATCH_INFO = [
		{
			label: t("mediaBatchInit.dispenseEntry.manufacturedOn"),
			val: formatDate(selectedContainerBatch?.created_at ?? "-"),
		},
		// {
		// 	label: t("mediaBatchInit.dispenseEntry.expiryDate"),
		// 	val: selectedContainerBatch?.expiry_date ?? "-",
		// 	// sub: t("mediaBatchInit.dispenseEntry.daysRemaining", { count: 313 }),
		// 	color: "text-emerald-500",
		// },
		// { label: t("mediaBatchInit.dispenseEntry.vendor"), val: "" },
		// {
		// 	label: t("mediaBatchInit.dispenseEntry.sterilizationBatch"),
		// 	val: "",
		// },
		// {
		// 	label: t("mediaBatchInit.dispenseEntry.qaStatus"),
		// 	val: selectedContainerBatch?.qa_status ?? "-",
		// 	color: "text-emerald-500",
		// },
	];

	return (
		<div className="space-y-4">
			<h4 className="text-[10px] font-black text-[#1E293B] uppercase tracking-[0.2em] flex items-center gap-2">
				{t("mediaBatchInit.dispenseEntry.batchInformation")}{" "}
				<span className="text-slate-400 font-medium tracking-normal">
					({t("mediaBatchInit.dispenseEntry.keyDetailsOnly")})
				</span>
			</h4>
			<div className="grid grid-cols-5 gap-4">
				{BATCH_INFO.map((item, i) => (
					<div
						key={i}
						className="bg-white p-3 rounded-2xl border border-slate-100 shadow-sm flex flex-col justify-center gap-1"
					>
						<p className="text-[8px] font-black text-slate-400 uppercase tracking-widest">
							{item.label}
						</p>
						<p
							className={`text-[11px] font-black text-slate-800`}
						>
							{item.val}
						</p>
						{/*{item.sub && (
							<p className="text-[8px] text-slate-400 font-bold uppercase">
								{item.sub}
							</p>
						)}*/}
					</div>
				))}
			</div>
		</div>
	);
};

export default BatchLotInfoCards;
